/** Fix common Whisper mishearings for ORM aviation terms before voice command. */
export function normalizePttQuery(text: string): string {
  let out = text.trim();
  if (!out) return out;

  // SOF (Supervisor of Flying) is often transcribed as SOD.
  out = out.replace(/\bSOD\b/gi, "SOF");

  return out;
}
